import { backend } from '../services/backend';
import { UploadIcon } from '../icons/upload';
import React, { useState } from 'react';
import { toast } from 'sonner';
import { userBackend } from '../services';

interface ModalLoaderProps {
  message: string;
  defaultPhotoUrl: string;
  onSave: (file: File) => void;
  closeModal: () => void;
}

const AvatarLoaderModal: React.FC<ModalLoaderProps> = ({ defaultPhotoUrl, onSave, closeModal }) => {
  const [selectedPhoto, setSelectedPhoto] = useState<File | null>(null); // Выбранное фото
  const [previewUrl, setPreviewUrl] = useState<string>(defaultPhotoUrl); // URL для предпросмотра

  const handlePhotoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedPhoto(file);
      setPreviewUrl(URL.createObjectURL(file)); // Генерация URL для предпросмотра
    }
  };

  const closeWithSave = () => {
    if (!selectedPhoto) return; // Передаем новое фото в callback
    userBackend.loadUserPhoto(selectedPhoto).then((res) => {
      toast("Фото обновлено");
      onSave(selectedPhoto); 
    }).catch((e) => {
      console.error(e);
      toast("Не удалось загрузить фото")
    }).finally(() => {
      closeModal();
    })
  };

  return (
    <div>
      <div className="modalHeading">
        <h3>Редактировать фото</h3>
      </div>
      <div className="loadPhotoContainer">
        <img
          src={previewUrl}
          alt="Preview"
          className="photoPreview"
          style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'cover' }}
        />
      </div>
      <label htmlFor="new-photo">
        <div className="photoUploadContainer gridCenter">
          <div className="columnCenter">
            <UploadIcon width={24} height={24} />
            <div className="uploadInnerHeading">
              Загрузить новое фото
            </div>
            <div className="uploadInnerDescripton">
              Разрешенные форматы: PNG, JPEG, JPG
            </div>
          </div>
        </div>
        <input
          type="file"
          id="new-photo"  // Добавляем id
          name="new-photo"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handlePhotoChange}
        />
      </label>
      <div className="flex between">
        <button onClick={closeModal} className="cancelButton">
          Отменить
        </button>
        <button onClick={closeWithSave} className="saveButton" disabled={!selectedPhoto}>
          Сохранить
        </button>
      </div>
    </div>
  );
};

export default AvatarLoaderModal;